export const Footer = () => {
  return (
    <footer className="footer sm:footer-horizontal footer-center bg-slate-100 text-base-content p-4">
      <aside>
        <p>
          Copyright © 2026 - All rights reserved{" "}
          <span className="block sm:inline">PT. Visi Ekosistem Digital</span>
        </p>
      </aside>
    </footer>
  );
};
